module.exports = __webpack_public_path__ + "media/3_2.2dcd3b80.wav";